var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-row",
    { staticClass: "table" },
    [
      _c("span", { staticClass: "title" }, [_vm._v("课程类别管理")]),
      _c(
        "el-row",
        { staticClass: "row-bg" },
        [
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "has",
                  rawName: "v-has",
                  value: "curriculum:CategoryAdd",
                  expression: "'curriculum:CategoryAdd'",
                },
              ],
              staticClass: "tb-button",
              attrs: { type: "info", size: "medium" },
              on: {
                click: function ($event) {
                  return _vm.addCategory()
                },
              },
            },
            [_vm._v("新 增")]
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%", "margin-bottom": "20px" },
          attrs: {
            data: _vm.tableArr,
            "row-key": "id",
            border: "",
            "default-expand-all": "",
            "tree-props": { children: "children", hasChildren: "hasChildren" },
          },
        },
        [
          _c("el-table-column", {
            attrs: { prop: "title", label: "类别名", align: "left" },
          }),
          _c("el-table-column", {
            attrs: { label: "操作", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.memberCategory(scope.row)
                          },
                        },
                      },
                      [_vm._v("成员管理")]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "has",
                            rawName: "v-has",
                            value: "curriculum:CategoryEdit",
                            expression: "'curriculum:CategoryEdit'",
                          },
                        ],
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.editCategory(scope.row)
                          },
                        },
                      },
                      [_vm._v("编 辑")]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "has",
                            rawName: "v-has",
                            value: "curriculum:CategoryDel",
                            expression: "'curriculum:CategoryDel'",
                          },
                        ],
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.delCategory(scope.row)
                          },
                        },
                      },
                      [_vm._v("删 除")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("add-category", {
        attrs: {
          show: _vm.categoryDialog,
          editData: _vm.editData,
          cascaderList: _vm.cascaderList,
        },
        on: {
          close: function ($event) {
            _vm.categoryDialog = false
            _vm.editData = null
          },
          updateCourseCatalog: _vm.updateCourseCatalog,
        },
      }),
      _c("member-category", {
        attrs: { show: _vm.memberDialog, catalogId: _vm.catalogId },
        on: {
          close: function ($event) {
            _vm.memberDialog = false
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }